<template>
  <div class="field-of-fields">
    <form v-if="!blogSuccessfullyPosted">
      <!-- {{ user }} -->
      <!-- <div class="form-group"> -->
        <label>Title*</label>
        <input type="text" class="form-control" v-model="title">
      <!-- </div> -->

      <!-- <div class="form-group"> -->
        <label>Hero Image</label>
        <input type="file" class="form-control-file" id="hero" ref="hero" v-on:change="handleFileUpload()"/>
      <!-- </div> -->

      <div class="editor blog mt-3">
        <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
        <editor-menu-bar :editor="contentEditor" v-slot="{ commands, isActive }" class="mb-1">
          <div class="menubar">
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
              <strong>B</strong>
            </button>
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
              <i>Italics</i>
            </button>
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
              <u>U</u>
            </button>
            <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
              Image
            </button> -->
            <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
              Image
            </button> -->
            <!-- https://github.com/scrumpy/tiptap/issues/89 -->
            <!-- https://codesandbox.io/s/j3p0z44155 -->
            <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
              Image
            </button> -->
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
              H1
            </button>
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
              H2
            </button>
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
              H3
            </button>
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
              List
            </button>
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
              1. 2. 3...
            </button>
            <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
              ""
            </button> -->
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
              ---
            </button>
            <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
              Undo
            </button>
            <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
              Redo
            </button> -->
          </div>
        </editor-menu-bar>

        <editor-menu-bubble class="menububble mb-1" :editor="contentEditor" @hide="hideLinkMenu" v-slot="{ commands, isActive, getMarkAttrs, menu }">
          <div
            class="menububble"
            :class="{ 'is-active': menu.isActive }"
            :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
          >

            <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
              <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
              <!-- <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button"> -->
              <button class="btn btn-grey btn-sm menubar__button" @click="setLinkUrl(commands.link, null)" type="button">
                <!-- <icon name="remove" /> -->
                <p>remove</p>
              </button>
            </form>

            <template v-else>
              <!-- <button
                class="menububble__button"
                @click="showLinkMenu(getMarkAttrs('link'))"
                :class="{ 'is-active': isActive.link() }"
              > -->
              <button
                class="btn btn-grey btn-sm menubar__button"
                @click="showLinkMenu(getMarkAttrs('link'))"
                :class="{ 'is-active': isActive.link() }"
              >
                <span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span>
                <!-- <icon name="link" /> -->
              </button>
            </template>

          </div>
        </editor-menu-bubble>

        <editor-content class="editor__content" :editor="contentEditor" />
      </div>

      <!-- <div class="form-group"> -->
        <label>Post Categories</label>
        <div class="form-check" v-for="(category, index) in categoryOptions" :key="'SelectCategories'+index">
          <input class="form-check-input" type="checkbox" :value="category" v-model="categories">
          <label class="form-check-label">
            {{ category }}
          </label>
        </div>
      <!-- </div> -->

      <hr>
      <button v-if="!postID" class="mylisting-button dark-button" @click.prevent="createPost()">Submit</button>
      <button v-if="postID" class="mylisting-button dark-button" @click.prevent="updatePost()">Update</button>
    </form>

    <div v-if="blogSuccessfullyPosted">
      <h2>Thank you for contributing to our blog!</h2>
      <h4 class="mb-4">Our team will review it and get back to you shortly when it is published.</h4>
      <router-link :to="{ name: 'Blog' }" class="mylisting-button dark-button mt-5">Blog</router-link>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
  // Import the editor
  import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap'
  // import Icon from 'Components/Icon'
  import {
    Blockquote,
    CodeBlock,
    HardBreak,
    Heading,
    HorizontalRule,
    OrderedList,
    BulletList,
    ListItem,
    TodoItem,
    TodoList,
    Bold,
    Code,
    Italic,
    Link,
    Strike,
    Underline,
    History,
    Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
  } from 'tiptap-extensions'

  export default {
    // props: ['postID'],
    components: {
      EditorContent,
      EditorMenuBar,
      EditorMenuBubble,
    },
    data() {
      return {
        userID: null,
        user: {},
        title: '',
        hero: '',
        content: '',
        contentEditor: null,
        categories: [],
        categoryOptions: [],

        blogSuccessfullyPosted: false,

        postID: null, // There should be a post ID when editing a post, but not when creating a new post
        postToEdit: {},

        linkUrl: null,
        linkMenuIsActive: false,
      }
    },
    mounted() {
      this.contentEditor = new Editor({
        // content: this.description,
        content: '',
        autoFocus: true,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3, 4, 5] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
        ],
        onUpdate: ({ getJSON, getHTML }) => {
          // this.json = getJSON()
          // this.html = getHTML()
          this.content = getHTML()
        },
      })
    },
    beforeDestroy() {
      this.contentEditor.destroy()
    },
    created() {
      this.userID = this.$store.getters.userID
      this.categoryOptions = this.$store.getters.blogCategories

      // this is for a unique route for editing a job /edit-job/id
      if (this.$route.params.id) {
        this.postID = this.$route.params.id
      }

      this.getUser()
    },
    methods: {
      getUser() {
        if (this.userID) {
          axios.get('/api/people/'+this.userID.toString())
            .then(res => {
              console.log(res)
              this.user = res.data

              // If postID is not null, that means we are editing an existing job
              if (this.postID) {
                console.log('Editing Blog Post')
                console.log(this.postID)
                axios.get('/api/blogposts/?id='.concat(this.postID.toString()))
                  .then(res => {
                    console.log(res.data[0])
                    this.postToEdit = res.data[0]

                    this.title = this.postToEdit.title
                    this.contentEditor.setContent(this.postToEdit.content)
                    this.content = this.postToEdit.content
                    this.categories = this.postToEdit.categories
                  })
                  .catch(error => console.log(error))
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
      // https://serversideup.net/uploading-files-vuejs-axios/
      handleFileUpload() {
        this.hero = this.$refs.hero.files[0];
      },
      createPost() {
        console.log(this.userID)
        console.log(this.title)

        axios.post('/api/blogposts/', {
          poster: this.userID,
          title: this.title,
          // hero_image: this.hero,
          content: this.content,
          categories: this.categories,

          // agency: 4,
          // agency_owner: 'ThriveHire',
          agency: this.$store.getters.agencyID,
          agency_owner: this.$store.getters.agencyName,
        })
          .then(res => {
            console.log(res)

            // Email to inform Hayley and I of new blog posts
            this.$store.dispatch('sendEmail',
              {
                subject: 'New Blog Post!',
                message: 'New blog posted with the title: '+this.title+'\nAuthor: '+this.user.email,
                // from: 'info@thrivehire.co',
                from: 'info@thrivehire.co',
                // email: 'aakash@enginehire.ca',
                email: 'info@thrivehire.org',
                reply: 'info@thrivehire.co',
                // userID: this.aakashid,
                userID: 4, // Hard coding to my production ID for now
              }
            )
            this.$store.dispatch('sendEmail',
              {
                subject: 'New Blog Post!',
                message: 'New blog posted with the title: '+this.title+'\nAuthor: '+this.user.email,
                // from: 'info@thrivehire.co',
                from: 'info@thrivehire.co',
                email: 'aakash@enginehire.ca',
                reply: 'info@thrivehire.co',
                // userID: this.aakashid,
                userID: 4, // Hard coding to my production ID for now
              }
            )

            if (this.hero) {
              let formData = new FormData();
              formData.append('hero_image', this.hero);

              // https://stackoverflow.com/questions/47787175/reset-input-type-file-using-vue-js
              this.$refs.hero.value = null;
              this.hero = '';

              axios.patch( '/api/blogposts/'.concat(res.data.id.toString()).concat('/'),
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              )
                .then(res => {
                  console.log(res)
                  // this.getUser()
                })

                .catch(error => {
                  console.log(error)
                })
            }

            this.blogSuccessfullyPosted = true
            // Scroll the window up
            window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
          })
          .catch(error => console.log(error))
      },
      updatePost() {
        console.log(this.userID)
        console.log(this.title)

        axios.patch('/api/blogposts/'+this.postID.toString()+'/', {
          // This was only to manually change post authors, normally when editing the author should not change
          // poster: this.userID,
          // poster: 2563, // Malaika
          // poster: 2561, // Tanya
          // poster: 2564, // Sara
          // poster: 2562, // Sarah
          // poster: 2746, // Chantelle
          // poster: 1069, // Hayley
          // poster: 2747, // Zac
          // poster: 2748, // Gautham
          // poster: 2749, // Divya
          // poster: 2711, // Humaira
          // poster: 2936, // Krithika
          // poster: 3054, // blogwriter@thrivehire.co
          title: this.title,
          // hero_image: this.hero,
          content: this.content,
          categories: this.categories,

          published: false, // When a blog post is edited, it should no longer be published
          // created_date: '2019-07-31T12:00:00',
        })
          .then(res => {
            console.log(res)

            // Email to inform Hayley and I of updated blog posts
            this.$store.dispatch('sendEmail',
              {
                subject: 'Updated Blog Post!',
                message: 'Blog posted updated with the title: '+this.title+'\nAuthor: '+this.user.email,
                // from: 'info@thrivehire.co',
                from: 'info@thrivehire.co',
                // email: 'aakash@enginehire.ca',
                email: 'info@thrivehire.org',
                reply: 'info@thrivehire.co',
                // userID: this.aakashid,
                userID: 4, // Hard coding to my production ID for now
              }
            )
            this.$store.dispatch('sendEmail',
              {
                subject: 'Updated Blog Post!',
                message: 'Blog posted updated with the title: '+this.title+'\nAuthor: '+this.user.email,
                // from: 'info@thrivehire.co',
                from: 'info@thrivehire.co',
                email: 'aakash@enginehire.ca',
                reply: 'info@thrivehire.co',
                // userID: this.aakashid,
                userID: 4, // Hard coding to my production ID for now
              }
            )

            if (this.hero) {
              let formData = new FormData();
              formData.append('hero_image', this.hero);

              // https://stackoverflow.com/questions/47787175/reset-input-type-file-using-vue-js
              this.$refs.hero.value = null;
              this.hero = '';

              axios.patch( '/api/blogposts/'.concat(res.data.id.toString()).concat('/'),
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              )
                .then(res => {
                  console.log(res)
                  // this.getUser()
                })

                .catch(error => {
                  console.log(error)
                })
            }

            this.blogSuccessfullyPosted = true
            // Scroll the window up
            window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
          })
          .catch(error => console.log(error))
      },

      // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Links/index.vue
      showLinkMenu(attrs) {
        this.linkUrl = attrs.href
        this.linkMenuIsActive = true
        this.$nextTick(() => {
          this.$refs.linkInput.focus()
        })
      },
      hideLinkMenu() {
        this.linkUrl = null
        this.linkMenuIsActive = false
      },
      setLinkUrl(command, url) {
        command({ href: url })
        this.hideLinkMenu()
      },
    },
  }
</script>

<style>
  .blog .ProseMirror {
    min-height: 250px;
  }

  /* .menububble__button {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    background: transparent;
    border: 0;
    color: #fff;
    padding: .2rem .5rem;
    margin-right: .2rem;
    border-radius: 3px;
    cursor: pointer;
  } */
</style>



// WEBPACK FOOTER //
// src/components/blog/BlogPostForm.vue